// extracted by mini-css-extract-plugin
export default {"button":"BlueButton_button__fdmvE","button__small":"BlueButton_button__small__sGMgC"};